import { observer } from 'mobx-react';
import Main from '../../../../../../BrowserSupport/Main';
import Notifications from '../../../../../../Notifications';
import I18nTitle from '../../../../../../Title/I18nTitle';
import Builder from './Builder';

function BuilderV2() {
  return (
    <>
      <I18nTitle title="Create a collection - AdminStudio" />
      <Notifications />
      <Main
        id="main"
        className="max-w-clientPortalMaxWidth w-full mx-auto relative flex flex-col flex-1"
      >
        <Builder />
      </Main>
    </>
  );
}

export default observer(BuilderV2);
